import React, { useEffect, useState } from "react";
import "./inventario.css";
import TablaInventario from "../inventarioTable/inventariotable";
import AutoresTable from "../autoresTable/autoresTable";
import ToggleSwitch from "../../categoriaToggle/categoriatoggle";

function Inventario() {
  const [category1, setCategory1] = useState(true);

  return (
    <div className="inventario-container">
      <div className="inventario-header">
        <h1>Inventario Management</h1>
        <div className="inventario-toggle">
          <ToggleSwitch
            isAcademic={category1}
            setIsAcademic={setCategory1}
            inventario={true}
          />
        </div>
      </div>
      <div className="inventario-tabla">
        {category1 === true ? <TablaInventario /> : <AutoresTable />}
      </div>
    </div>
  );
}

export default Inventario;

